import { render, staticRenderFns } from "./GlobbingConfigSave.vue?vue&type=template&id=6f1947b8&scoped=true"
import script from "./GlobbingConfigSave.vue?vue&type=script&lang=js"
export * from "./GlobbingConfigSave.vue?vue&type=script&lang=js"
import style0 from "./GlobbingConfigSave.vue?vue&type=style&index=0&id=6f1947b8&prod&scoped=true&lang=css"
import style1 from "./GlobbingConfigSave.vue?vue&type=style&index=1&id=6f1947b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1947b8",
  null
  
)

export default component.exports